{
  "help": "Aiuto",
  "info": "Informazioni"
}
